import React from 'react';
import {BaseModal} from '../comun/Index';
import { TextField, Autocomplete } from '@mui/material';
import axios from 'axios';

const guardarPersona = function(datos){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/personas/todos/';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, datos, config)
    .then((res) => resolve(res.data))
    .catch((error) => reject(error));
  })
}

export default class Nueva extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      documento:"",
      apellidos:"",
      nombres:"",
      localidadSelec:null
    }
  }
  componentDidMount(){ }

  guardar(){
    const {documento, apellidos, nombres, localidadSelec} = this.state;
    let persona = {documento, apellidos, nombres, localidad:localidadSelec.descripcion, localidad_id:localidadSelec.id};
    guardarPersona(persona)
    .then((persona_id) => {
      persona.persona_id = persona_id
      this.props.guardado(persona);
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error");
    })
  }

  render(){
    const {documento, nombres, apellidos, localidadSelec} = this.state;
    const {salir, localidades} = this.props;
    return(
      <BaseModal
        titulo="Nueva persona"
        loading={false}
        botonera={[
          {titulo:"Salir", backgroundColor:'#FF2C00', onClick: () => salir()},
          {titulo:"Guardar", backgroundColor:'#00B845', onClick: () => this.guardar()}
        ]}
      >
        <div style={{width:'100%', borderRadius:10, backgroundColor:'white', padding:10, margin:10, display:'flex', flexDirection:'column'}}>
          <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
            <TextField
              size="small"
              style={{flex:1,textAlign:'center',minWidth:0,margin:'5px 1px'}}
              inputProps={{style:{textAlign:'center'}}}
              label="Documento"
              value={documento}
              onChange={(e) => this.setState({documento:e.target.value})}
              variant="outlined"
            />
            <Autocomplete
              value={localidadSelec}
              onChange={(e,n) => this.setState({localidadSelec:n})}
              isOptionEqualToValue={(option, value) => option.id === value.id }
              slotProps={{style:{textAlign:'center'}}}
              options={localidades}
              getOptionLabel={(option) => option.descripcion}
              size="small"
              disableClearable
              style={{margin:'5px 1px',flex:1, fontSize:5}}
              fontSize="small"
              renderInput={(params) => <TextField {...params} label="Localidad"/>}
            />
          </div>
          <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
            <TextField
              size="small"
              style={{flex:1,textAlign:'center',minWidth:0,margin:'5px 1px'}}
              inputProps={{style:{textAlign:'center'}}}
              label="Apellidos"
              value={apellidos}
              onChange={(e) => this.setState({apellidos:e.target.value})}
              variant="outlined"
            />
            <TextField
              size="small"
              style={{flex:1,textAlign:'center',minWidth:0,margin:'5px 1px'}}
              inputProps={{style:{textAlign:'center'}}}
              label="Nombres"
              value={nombres}
              onChange={(e) => this.setState({nombres:e.target.value})}
              variant="outlined"
            />
          </div>
          <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
          </div>
        </div>
      </BaseModal>
    );
  }
}